var map = {
	"./add-event.svg": 2019,
	"./alm.svg": 6588,
	"./calendar-big.svg": 9558,
	"./calendar.svg": 3055,
	"./doors-img.svg": 7721,
	"./error.svg": 6497,
	"./forgot-password.svg": 1607,
	"./google-icon.svg": 4921,
	"./google-sync-icon.svg": 4740,
	"./icon_calendar_sync.svg": 8081,
	"./link-sent-icon.svg": 1702,
	"./link-sent.svg": 9559,
	"./log-out.svg": 6831,
	"./login-image.svg": 581,
	"./logo_calizy_pro.svg": 9308,
	"./member-available-img.svg": 3810,
	"./outllook-sync-icon.svg": 3673,
	"./outlook-icon.svg": 7619,
	"./private-image.svg": 5157,
	"./warning-icon.svg": 2191,
	"./well-done.svg": 8835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7729;